import classNames from "classnames";
import { useRef } from "react";
import { useInteractionStates } from "../../../hooks/useInteractionStates";
import { BuilderComponentProps } from "../../BuilderInterface";
import { getCompoundStyle, getStateStyleForBuilder, getStylesFromInteractiveStates } from "../../helpers";
import "./styles.scss";

const BuilderSmartTile: React.FC<BuilderComponentProps> = ({
    node,
    children,
    actionCallbacks,
    builderProps
}: BuilderComponentProps) => {
    const { id, attr, stateManager } = node;
    const { setElement, states } = useInteractionStates<HTMLDivElement>();
    const div = useRef<HTMLDivElement>(null);

    const builderSmartTileClass = classNames("builder-smart-tile", {
        [`${attr?.className}`]: !!attr?.className
    });

    if (builderProps) {
        const {
            isContainer,
            nodeState,
            selectedMenu,
            selectCallback,
            outlineCallback,
            onDragOverCapture,
            onDragStart,
            onDragEnd
        } = builderProps;

        return (
            <div
                {...attr}
                ref={div}
                className={`${builderSmartTileClass}`}
                style={getCompoundStyle({
                    node,
                    isContainer: isContainer,
                    stateStyle: getStateStyleForBuilder(stateManager, nodeState, "attr_style")
                })}
                onClick={e => (selectCallback ? selectCallback(e, id) : {})}
                onMouseMove={e => (outlineCallback ? outlineCallback(e, id) : {})}
                id={id}
                onDragOverCapture={e => onDragOverCapture?.(e, id, div.current as HTMLDivElement)}
                onDragStart={e => onDragStart?.(e, id)}
                draggable={"true"}
                onDragEnd={onDragEnd}
            >
                {children}
                {selectedMenu}
            </div>
        );
    } else {
        const { style, ...rest } = attr || {};

        const smartTileStyle = getStylesFromInteractiveStates({
            states,
            defaultStyle: getCompoundStyle({ node }),
            stateManager,
            paths: ["attr_style"]
        });

        return (
            <div ref={setElement} style={smartTileStyle} id={id} {...rest} {...actionCallbacks} className={builderSmartTileClass}>
                {children}
            </div>
        );
    }
};

export default BuilderSmartTile;
